module.exports = "<div *ngIf='!isUploadForm'>\n  <div *ngFor='let f of files' class='file'>\n    <a target='_blank' [href]='f.path'>{{f.filename}} [{{f.size}} kB]</a>\n  </div>\n  <button (click)='switchUploadForm()'>Upload form</button>\n</div>\n\n<div *ngIf='isUploadForm'>\n  <div [innerHTML]='iframe'></div>\n  <div>\n    <button (click)='switchUploadForm()'>CANCEL</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/upload-box/upload-box.component.html
// module id = ../../../../../src/app/upload-box/upload-box.component.html
// module chunks = main